module.exports = __webpack_public_path__ + "static/img/meizhilu_icon.a7d0f49.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/meizhilu_icon.png
// module id = J3kd
// module chunks = 1